module.exports = __webpack_public_path__ + "static/20230619_142-0258452b29a07f54f7b205f43d3d7c3d.jpg";